<div fxLayout="column" class="fxGap-large">
  <h3 class="prompt-question">
    You are currently enrolled with benefits in the {{dualEnrollment?.otherAgency === 'SEBB' ? 'School' : 'Public'}} Employees Benefit Board ({{dualEnrollment?.otherAgency ?? 'SEBB'}})
    Program. Individuals are limited to a single enrollment in medical, dental and vision plans in either the PEBB or SEBB program. You can either choose to
    waive medical/dental/vision benefits in {{dualEnrollment?.currentAgency ?? 'PEBB'}} to remain in those benefits in {{dualEnrollment?.otherAgency ?? 'SEBB'}},
    or you can continue enrolling in {{dualEnrollment?.currentAgency ?? 'PEBB'}} medical/dental/vision benefits and have the Health Care Authority (HCA)
    terminate your dual enrollment in those same {{dualEnrollment?.otherAgency ?? 'SEBB'}} benefits.  NOTE: {{dualEnrollment?.currentAgency ?? 'PEBB'}}
    medical/dental/vision benefits cannot be waived to enroll or remain enrolled in medical with a {{dualEnrollment?.otherAgency ?? 'SEBB'}} employer that
    offers only medical coverage
  </h3>
  <div class="mgbt-medium-lg" style="padding-left: 75px; padding-right: 75px" fxLayout="row" fxLayoutAlign="space-between">
    <div fxFlexFill class="mgtp-small" fxLayout="row" fxLayoutAlign="space-around">
      <button (click)="waive.emit()" class="btn btn-secondary">Waive Enrollment</button>
      <button (click)="continueEnrollment()" class="btn btn-primary">Continue Enrolling</button>
    </div>
  </div>
  <div *ngIf="!hideBackToDash" fxFlexFill fxLayout="row" fxLayoutAlign="center center">
    <button (click)="backToDash.emit()" class="btn btn-secondary mgtp-medium-lg">Back to dashboard</button>
  </div>
</div>
